import EventoEntity from '@/pages/eventi/generale/EventoEntity';
import AssociatoEntity from '@/pages/anagrafica/associati/AssociatoEntity';

export default function (partecipazione) {
  this.id = partecipazione ? partecipazione.id : null;
  this.Evento = partecipazione ? new EventoEntity(partecipazione.Evento) : new EventoEntity();
  this.Iscritto = partecipazione ? new AssociatoEntity(partecipazione.Iscritto) : new AssociatoEntity();
  this.StatoIscrizione = partecipazione ? partecipazione.StatoIscrizione : 'Prenotato';
  this.isAttivo = partecipazione ? partecipazione.isAttivo : false;
  this.isPostoRiservato = partecipazione ? partecipazione.isPostoRiservato : false;
  this.isPresente = partecipazione ? partecipazione.isPresente : false;
  this.DataPrenotazione = partecipazione ? partecipazione.DataPrenotazione : null;
  this.DenominazioneAbbinato = partecipazione ? partecipazione.DenominazioneAbbinato : null;
  this.DataIscrizione = partecipazione ? partecipazione.DataIscrizione : null;
  this.DataPagamento = partecipazione ? partecipazione.DataPagamento : null;
  this.Categoria = partecipazione ? new TipoCategoriaEntity(partecipazione.TipoEvento) : new TipoCategoriaEntity();
  this.UserPrenotazione = partecipazione ? partecipazione.UserPrenotazione : null;
  this.UserIscrizione = partecipazione ? partecipazione.UserIscrizione : null;
  this.Note = partecipazione ? partecipazione.Note : null;
}

function TipoCategoriaEntity(t) {
  this.id = t ? t.id : null;
  this.Codice = t ? t.Codice : null;
  this.Descrizione = t ? t.Descrizione : null;
  this.Tipo = t ? t.Tipo : null;
}
